import { render, staticRenderFns } from "./business-profile.vue?vue&type=template&id=083edd1c&scoped=true"
import script from "./business-profile.vue?vue&type=script&lang=js"
export * from "./business-profile.vue?vue&type=script&lang=js"
import style0 from "./business-profile.vue?vue&type=style&index=0&id=083edd1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083edd1c",
  null
  
)

export default component.exports